

/* BEGIN hydration-carrier-buyer-highlights-20260731 */
;(function () {
  var expected = ["Robust 900D polyester, secure KAM buckles, and breathable mesh back padding provide water-repellent, abrasion-resistant durability and carrying comfort.","A hydration-tube outlet and retaining webbing help keep the tube positioned, while MOLLE webbing, a hook-and-loop patch area, and shoulder-strap D-rings expand attachment and personalization options.","A top carry handle, adjustable chest strap (up to 60 in), adjustable waist belt (up to 52 in), and rescue-whistle buckle support a flexible fit and can help attract attention in an emergency."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-tactical-molle-hydration-carrier-pack-backpack-great-for-outdoor-sports-of-running-hiking-camping-cycling-motorcycle-fit-2l-or-2-5l-water-bladdernot-included') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END hydration-carrier-buyer-highlights-20260731 */
